// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DraftComboboxItem__draftComboboxItem___ggtQA {
    position: relative;
    text-decoration: none;
    background: var(--color-control-bg-clear);
    transition: color 0.3s;

    &[aria-selected='true'] {
        color: var(--color-control-typo-secondary);
        background: var(--color-bg-stripe);

        &::before {
            content: '';

            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;

            width: var(--space-3xs);

            background-color: var(--color-control-typo-secondary);

            transition: opacity 0.2s;
        }
    }

    &:hover {
        background-color: var(--color-control-bg-clear-hover);
    }
}
`, "",{"version":3,"sources":["webpack://./../GM.Frontend.Library/src/components/DraftCombobox/DraftComboboxItem/DraftComboboxItem.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,yCAAyC;IACzC,sBAAsB;;IAEtB;QACI,0CAA0C;QAC1C,kCAAkC;;QAElC;YACI,WAAW;;YAEX,kBAAkB;YAClB,MAAM;YACN,SAAS;YACT,OAAO;;YAEP,uBAAuB;;YAEvB,qDAAqD;;YAErD,wBAAwB;QAC5B;IACJ;;IAEA;QACI,qDAAqD;IACzD;AACJ","sourcesContent":[".draftComboboxItem {\n    position: relative;\n    text-decoration: none;\n    background: var(--color-control-bg-clear);\n    transition: color 0.3s;\n\n    &[aria-selected='true'] {\n        color: var(--color-control-typo-secondary);\n        background: var(--color-bg-stripe);\n\n        &::before {\n            content: '';\n\n            position: absolute;\n            top: 0;\n            bottom: 0;\n            left: 0;\n\n            width: var(--space-3xs);\n\n            background-color: var(--color-control-typo-secondary);\n\n            transition: opacity 0.2s;\n        }\n    }\n\n    &:hover {\n        background-color: var(--color-control-bg-clear-hover);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"draftComboboxItem": `DraftComboboxItem__draftComboboxItem___ggtQA`
};
export default ___CSS_LOADER_EXPORT___;
